import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Container } from "react-bootstrap";
import { withRouter } from "react-router-dom";

import "./CdList.scss";

// verificar
// import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner"
import messages from '../../assets/i18n';
import ItemList from '../../containers/ItemList/ItemList';
import { HeaderActions } from '../../components';

function CdList(props) {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch({ type: 'GET_CDS' })
		// eslint-disable-next-line
	}, [])

	const lang = useSelector(state => state.language.name);

	const cdDetailsPage = (id) => {
		dispatch({ 
			type: "CD_SELECT", 
			id: id 
		});

		props.history.push(`/cd-details`);
	}

	const pageBack = () => {
		dispatch({ type: "CD_CLEAN" });
		props.history.push(`/main`);
	};

	const cdList = useSelector(state => state.cdList);
	
	const header = [
    messages[lang].code, 
    messages[lang].name, 
    messages[lang].city, 
    messages[lang].federationUnity, 
    messages[lang].company
	];

	const listTable = cdList.map((value, index) => ([
    {
			text: value.codigo,
      onClick: () => {cdDetailsPage(value.codigo)},
    },
    {
			text: value.nome,
			maxLength: 40
    },
    {
			text: value.cidade,
			maxLength: 40
    },
		value.uf,
		{
			text:value.empresas.join(", "),
		}
	]));
	
	const ButtonStandardLoadList = () => <></>

  const titlePage = messages[lang].distributionCenterListTitle;
  const titleTable = messages[lang].distributionCenter;

	return (
		<div className="cd-list-page">
			<HeaderActions 
        pageBack={pageBack} 
        ButtonAction={ButtonStandardLoadList}
        titlePage={titlePage} />

			<Container className="mt-3 pt-2 mb-5 pb-5">
        <ItemList header={header} titleTable={titleTable} listTable={listTable} />
      </Container>

		</div>
	)

}

export default withRouter(CdList);